module.exports = __webpack_public_path__ + "img/579.272eef0e.jpg";